export const res_list = {
  mounted: function(){
    if(this.$refs.general_select
      && this.$route.query.layer){
      this.target.layer = this.$route.query.layer;
      if(this.target.layer === "group"){
        if(this.$store.getters.user.role === "organization_manager"){
          if(this.$route.query.gid){
            this.target.gid = this.$route.query.gid;
          }
        }else{
          this.target.gid = this.$store.getters.user.gid;
        }
      }else if(this.target.layer === "user"){
        if(["organization_manager", "group_manager"].indexOf(this.$store.getters.user.role) >= 0){
          if(this.$route.query.uid){
            this.target.uid = this.$route.query.uid;
          }
        }else{
          this.target.uid = this.$store.getters.user.uid;
        }
      }
      if((this.target.layer === "organization"
        || (this.target.layer === "group" && this.target.gid !== "")
        || (this.target.layer === "user" && this.target.uid !== ""))){
        if(this.target.layer === "organization"){
          this.$refs.general_select.groups = [];
          this.$refs.general_select.users = [];
        }else if(this.target.layer === "group"
          && this.$store.getters.user.role === "organization_manager"){
          this.$refs.general_select.get_data("/" + this.get_prefix() + "group/list", "gid", "groups");
        }else if(this.target.layer === "user"){
          this.$refs.general_select.get_data("/" + this.get_prefix() + "user/list", "uid", "users");
        }
        this.get_data(this.get_prefix() + this.module, this.get_id());
      }
    }
  },
  methods: {
    get_data: function(module, extra_path) {
      this.progress_overlay = true;
      this.progress = 0;
      this.data = [];
      this.$http.get(this.$store.getters.api_endpoint + "/" + module + extra_path,
                     {
                       onDownloadProgress: function( progressEvent ) {
                         this.progress = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ));
                       }.bind(this)
                     })
        .then( response => {
          this.progress = 100;
          this.progress_overlay = false;
          if(this.$store.getters.debug){
            console.log("response.data:" + JSON.stringify(response.data));
          }
          this.data = response.data;
        })
        .catch( error => {
          this.progress_overlay = false;
          if(this.http_error(error)){
            // 404だと何もしない
            if(error.response.status !== 404){
              this.$store.commit("setNotification", {
                type: "error",
                message: error.response.data
              });
            }
          }
        });
    },
    get_id: function(){
      if(this.mode === "user"){
        return "";
      }
      if(this.target.layer === "organization"){
        return "/list/*";
      }else if(this.target.layer === "group"){
        return "/list/" + this.target.gid;
      }else{
        return "/list/" + this.target.uid;
      }
    },
    get_referer: function(module, mode="referer"){
      let referers = [];
      if(module === "file"){
        // ファイル一覧の検索情報を保持
        referers.push("file_type=" + (this.search_file_type.length === this.file_types.length ? "all" : this.search_file_type));
        if(this.search_fid){
          referers.push("fid=" + this.search_fid);
        }
        if(this.search_file){
          referers.push("file_name=" + this.search_file);

        }
      }else if(module === "job") {
        // ジョブ一覧の検索情報を保持
        referers.push("job_type=" + (this.search_job_type.length === this.job_types.length ? "all" : this.search_job_type));
        referers.push("status=" + (this.search_status.length === this.statuses.length ? "all" : this.search_status));
        if(this.search_jid){
          referers.push("search_jid=" + this.search_jid);
        }
        if(this.search_job){
          referers.push("search_job=" + this.search_job);
        }
      }
      if(this.mode !== "user"){
        referers.push("layer=" + this.target.layer);
        if(this.target.layer === "user"){
          referers.push("uid=" + this.target.uid);
        }
        if(this.target.layer === "group"
          && this.$store.getters.user.role === "organization_manager"){
          referers.push("gid=" + this.target.gid);
        }
      }
      if(mode === "nav_path"){
        return referers.length > 0 ? encodeURIComponent("/" + this.get_prefix() + module + "?" + referers.join("&")) : '';
      }else{
        // mode === "referer" (default)
        return referers.length > 0 ? "?referer=" + encodeURIComponent("/" + this.get_prefix() + module + "?" + referers.join("&")) : '';
      }
    },
    get_prefix: function(){
      if(this.mode === "user"){
        return "";
      }else{
        return this.mode + "/";
      }
    },
    confirm_delete_data: function(module, ids, extra_path){
      if(!this.$refs.delete_confirm){
        return;
      }
      this.$refs.delete_confirm.open()
        .then( result => {
          if(result){
            this.delete_data(module, ids, extra_path);
          }
        });
    },
    delete_data: function(module, ids, extra_path){
      var url = this.$store.getters.api_endpoint + "/" + module + "/" + ids.join("/");
      this.$http.delete(url)
        .then( response => {
          this.$store.commit("setNotification", {
            type: "success",
            message: {
              eid: "E1" + this.module_id + "002" + ":00000000",
              param: {}
            }
          });
          this.get_data(module, extra_path);
        })
        .catch( error => {
          if(this.http_error(error)){
            this.$store.commit("setNotification", {
              type: "error",
              message: error.response.data
            });
          }
        });
    },
    deletable: function(data){
      if(this.$store.getters.debug){
        console.log(this.mode);
      }
      if(this.mode === "user"){
        return this.$store.getters.user.uid === data.uid;
      }else if(this.mode === "group"){
        return this.$store.getters.user.gid === data.gid;
      }else{  // organization
        return true;
      }
    },
    reset_target: function(){
      if(this.$store.getters.user.role === "organization_manager"){
        this.target.gid = "";
      }
      if(["organization_manager", "group_manager"].indexOf(this.$store.getters.user.role) >= 0){
        this.target.uid = "";
      }
    }
  },
  computed: {
    refreshable: function(){
      if(this.mode === "user"){
        return true;
      }
      if(this.target.layer === "organization"){
        return this.target.nid !== "";
      }else if(this.target.layer === "group"){
        return this.target.gid !== "";
      }else{
        return this.target.uid !== "";
      }
    }
  }
}
